import type { DxToolRegistry } from '@kerberos-compliance/compliance-shared-ui/dx';
import { DxLevelMap, DxToolKindMap, DxToolStatusMap } from '@kerberos-compliance/compliance-shared-ui/dx';

export const dxToolRegistry = {
  'app-status': {
    label: 'Application Status & Diagnostics',
    kind: DxToolKindMap.Inspector,
    level: DxLevelMap.OptIn,
    status: DxToolStatusMap.Implemented,
    answers:
      'What is the current runtime environment, build configuration, route context, active user session, and platform connectivity status?',
    owner: 'platform-team',
    reviewBy: '2027-03-01',
    ticket: 'KCP-DX-01',
  },
  'local-storage': {
    label: 'Local Storage Inspector',
    kind: DxToolKindMap.Inspector,
    level: DxLevelMap.OptIn,
    status: DxToolStatusMap.Implemented,
    answers:
      'What keys and cached payloads exist in browser local storage for this application, and what are their sizes, expirations and redacted values?',
    owner: 'platform-team',
    reviewBy: '2027-03-01',
    ticket: 'KCP-DX-02',
  },
  'grants-inspector': {
    label: 'User Grants & IAM Roles',
    kind: DxToolKindMap.Inspector,
    level: DxLevelMap.OptIn,
    status: DxToolStatusMap.Implemented,
    answers: 'Which IAM roles, grants, tenant mappings, and token claims does the currently active session possess?',
    owner: 'platform-team',
    reviewBy: '2027-03-01',
    ticket: 'KCP-DX-03',
  },
  'a11y-i18n-inspector': {
    label: 'Accessibility & i18n Diagnostic',
    kind: DxToolKindMap.Inspector,
    level: DxLevelMap.NonProduction,
    status: DxToolStatusMap.Implemented,
    answers: 'Which translation keys are missing at runtime, and where is focus right now?',
    owner: 'platform-team',
    reviewBy: '2027-03-01',
    ticket: 'KCP-DX-04',
  },
  'ui-dev-mode': {
    label: 'UI Dev Mode',
    kind: DxToolKindMap.Actuator,
    level: DxLevelMap.OptIn,
    status: DxToolStatusMap.Implemented,
    answers:
      'What raw value is behind what this screen shows, e.g. the search score behind an organization relevance bar?',
    owner: 'platform-team',
    reviewBy: '2027-03-01',
  },
  'sentry-trigger': {
    label: 'Sentry Error Trigger',
    kind: DxToolKindMap.Actuator,
    level: DxLevelMap.NonProduction,
    status: DxToolStatusMap.Implemented,
    answers: 'Does an error of this shape reach Sentry, and with which normalization?',
    owner: 'platform-team',
    reviewBy: '2026-11-01',
    ticket: 'KCP-1241',
  },
} as const satisfies DxToolRegistry;

export type DxToolId = keyof typeof dxToolRegistry;

export const dxToolIds = Object.keys(dxToolRegistry) as DxToolId[];
